import { type PropsWithChildren, type ReactElement } from 'react';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';

import styles from './PropertyInfoContainer.module.css';

export const PropertyInfoContainer = ({ children }: PropsWithChildren): ReactElement => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();

  return (
    <div className={styles.container} data-is-narrow={isUAExclusiveListingAndNotSignedIn}>
      {children}
    </div>
  );
};
